import { render, staticRenderFns } from "./tab-rejected.vue?vue&type=template&id=36c38758&"
import script from "./tab-rejected.vue?vue&type=script&lang=js&"
export * from "./tab-rejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports